import React from "react";
import { useFavoriteMarkets } from "./FavoriteMarkets";
import { getLabel } from "../../InitData";

export default function FavoritesButton(props) {
    const favorites = useFavoriteMarkets();

    if (favorites == null || Object.keys(favorites).length === 0) {
        return null;
    }

    return (
        <div {...props}>{getLabel('general.favorites')}</div>
    );
}
